// extracted by mini-css-extract-plugin
export var bodySections = "_da-8";
export var gray = "_da-7";
export var green = "_da-4";
export var iconContainer = "_da-9";
export var iconWidgetContainer = "_da-1";
export var phoneIcon = "_da-2";
export var red = "_da-5";
export var statusDot = "_da-3";
export var widgetContainer = "_da-0";
export var yellow = "_da-6";